import type { FC } from "react";
import { useState } from "react";

import type { ColumnsType, AnyObject } from "@similarweb/pro-logic-components";
import { Tabs, Tab } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { multiIncludeExcludeType } from "app/components/multi-include-exclude-filter/consts";
import { MultiIncludeExcludeFilterContainer } from "app/components/multi-include-exclude-filter/MultiIncludeExcludeFilterContainer";
import { useSearchAdvertisingDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useSearchAdvertisingDataAndParams";
import type { ISortProps } from "app/pages/digital-marketing/ad-intelligence/common/utils/utils";
import { EAdsTabs } from "app/components/React/PlaResearch/type";
import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { FiltersContainer } from "./search-ads-table/StyledComponents";
import { SearchAdsWebsiteTable } from "./SearchAdsWebsiteTable";
import { ChipdownItem, TabListStyled } from "app/components/keyword-research/website-search-ads/styledComponents";

interface ISearchAdsWebsitePageProps {
    withAddToDashboard?: boolean;
    getColumnsFunction?: (
        visibleColumns: string[],
        currentPage: number,
        pageSize: number,
        sortConfig?: ISortProps,
        toggleExpandRow?: (key: number) => void,
        total?: number,
    ) => ColumnsType<AnyObject>;
}

export const SearchAdsWebsitePage: FC<ISearchAdsWebsitePageProps> = ({
    withAddToDashboard = true,
    getColumnsFunction,
}) => {
    const { selectedPageTab } = useSearchAdvertisingDataAndParams();
    const [selectedPageTabIndex, setSelectedPageTabIndex] = useState<EAdsTabs>(
        EAdsTabs[selectedPageTab as keyof typeof EAdsTabs],
    );

    const onPageTabSelect = (index: number) => {
        const selectedTabKey = EAdsTabs[index];
        setSelectedPageTabIndex(EAdsTabs[EAdsTabs[index]]);
        void proNavigator.updateParams({
            selectedPageTab: selectedTabKey,
        });
    };

    return (
        <Stack gap="24px">
            <Tabs
                onSelect={onPageTabSelect}
                selectedIndex={selectedPageTabIndex}
            >
                <TabListStyled size={"lg"}>
                    <Tab id={EAdsTabs.Text}>{translate("website.ads.pages.tab.text")}</Tab>
                    <Tab id={EAdsTabs.Product}>{translate("website.ads.pages.tab.shopping")}</Tab>
                </TabListStyled>
                <FiltersContainer>
                    <ChipdownItem>
                        <MultiIncludeExcludeFilterContainer filterType={multiIncludeExcludeType.KEYWORD} />
                    </ChipdownItem>
                    <ChipdownItem>
                        <MultiIncludeExcludeFilterContainer filterType={multiIncludeExcludeType.URL} />
                    </ChipdownItem>
                </FiltersContainer>
                <SearchAdsWebsiteTable
                    withAddToDashboard={withAddToDashboard}
                    getColumnsFunction={getColumnsFunction}
                />
            </Tabs>
        </Stack>
    );
};
